import { AnyAction, Dispatch } from 'redux';
import { ApiStatuses } from '../../../../global/models/api-model';
import { OfficerAdminState, OfficerAdminStateActions, Officer } from './institution-officers-models';


const InitialState: OfficerAdminState =
{
	groupAdmins: null,
	officers: null,
	officersLoaded: false,
	requesting: false,
	groupAdminsLoaded: false,
	requestingGroupAdmin: false,
	addOfficerStatus: ApiStatuses.None,
	reInviteStatus: ApiStatuses.None,
	removeStatus: ApiStatuses.None,
	officerToRemove: null,
	addAdminOfficerTempPw: null,
};



export const officerAdminReducer = (state = InitialState, action: AnyAction): OfficerAdminState => {

	switch (action.type) {

		case OfficerAdminStateActions.SET_INSTITUTION_OFFICERS:
			return {
				...state,
				officers: action.payload,
				officersLoaded: true,
			};

		case OfficerAdminStateActions.ADD_OFFICER_STATUS:
			return {
				...state,
				addOfficerStatus: action.payload,
			};

		case OfficerAdminStateActions.REINVITE_OFFICER_STATUS:
			return {
				...state,
				reInviteStatus: action.payload,
			};
		case OfficerAdminStateActions.REMOVE_OFFICER_STATUS:
			return {
				...state,
				removeStatus: action.payload,
			};

		case OfficerAdminStateActions.STAGE_OFFICER_TO_REMOVE:
			return {
				...state,
				officerToRemove: action.payload,
			};

		case OfficerAdminStateActions.SET_GROUP_ADMINS:
			return {
				...state,
				groupAdmins: action.payload,
				requestingGroupAdmin: false,
				groupAdminsLoaded: true,
			};

		case OfficerAdminStateActions.BEGIN_REQUEST_GROUP_ADMINS:
			return {
				...state,
				requestingGroupAdmin: true,
			};

		case OfficerAdminStateActions.END_REQUEST_GROUP_ADMINS:
			return {
				...state,
				requestingGroupAdmin: false,
			};


		case OfficerAdminStateActions.UNLOAD_INSTITUTION_OFFICERS:
			return {
				groupAdmins: null,
				officers: null,
				officersLoaded: false,
				requesting: false,
				groupAdminsLoaded: false,
				requestingGroupAdmin: false,
				addOfficerStatus: ApiStatuses.None,
				reInviteStatus: ApiStatuses.None,
				removeStatus: ApiStatuses.None,
				officerToRemove: null,
				addAdminOfficerTempPw: null,
			};
		case OfficerAdminStateActions.SET_TEMP_PASSWORD:
			return {
				...state,
				addAdminOfficerTempPw: action.payload,
			};

		default: return state;
	}
};


export const setOfficers = (officers: Officer[]) => {
	return {
		type: OfficerAdminStateActions.SET_INSTITUTION_OFFICERS,
		payload: officers,
	};
};

export const unloadOfficersState = () => {
	return {
		type: OfficerAdminStateActions.UNLOAD_INSTITUTION_OFFICERS,
	};
};

export const dispatchSetOfficers = (response: any, dispatch: Dispatch<any>) => {
	dispatch(setOfficers(response?.data));
};



export const setGroupAdmins = (officers: Officer[]) => {
	return {
		type: OfficerAdminStateActions.SET_GROUP_ADMINS,
		payload: officers,
	};
};

export const beginGroupAdminRequest = () => {
	return {
		type: OfficerAdminStateActions.BEGIN_REQUEST_GROUP_ADMINS,
	};
};

export const endGroupAdminRequest = () => {
	return {
		type: OfficerAdminStateActions.END_REQUEST_GROUP_ADMINS,
	};
};


export const dispatchSetGroupAdmins = (response: any, dispatch: Dispatch<any>) => {
	dispatch(setGroupAdmins(response?.data));
};

export const setAddOfficerStatus = (status: ApiStatuses): AnyAction => {
	return {
		type: OfficerAdminStateActions.ADD_OFFICER_STATUS,
		payload: status,
	};
};

export const setReinviteStatus = (status: ApiStatuses): AnyAction => {
	return {
		type: OfficerAdminStateActions.REINVITE_OFFICER_STATUS,
		payload: status,
	};
};

export const setRemoveStatus = (status: ApiStatuses): AnyAction => {
	return {
		type: OfficerAdminStateActions.REMOVE_OFFICER_STATUS,
		payload: status,
	};
};

export const stageOfficerAdminToDelete = (officer: Officer): AnyAction => {
	return {
		type: OfficerAdminStateActions.STAGE_OFFICER_TO_REMOVE,
		payload: officer,
	};
};

export const setTempPassword = (password: string) => {
	return {
		type: OfficerAdminStateActions.SET_TEMP_PASSWORD,
		payload: password,
	};
};
